import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model"
import type { IWorkspaceNoteRecipient } from "@/workspace/interfaces/api/workspace-note-recipient.interface"

export class WorkspaceNoteRecipient extends BaseModel implements IWorkspaceNoteRecipient {
  public static className = "WorkspaceNoteRecipient"
  public static verboseName = "werkruimtenotitieontvanger"
  public static override managedResolveFields = ["knownBusinessEntityContact"]

  declare id: string
  note: string
  knownBusinessEntityContact: KnownBusinessEntityContact

  constructor(recipient: IWorkspaceNoteRecipient, managed = false) {
    super(recipient)
    this.note = recipient.note
    this.knownBusinessEntityContact = ModelFactory.childModel(
      KnownBusinessEntityContact,
      recipient.knownBusinessEntityContact,
      managed
    )
  }
}
